import {Directive, forwardRef} from '@angular/core';
import {FormControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
    selector: '[lvMonthValidator]',
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MonthValidatorDirective),
        },
    ],
    standalone: false
})
export class MonthValidatorDirective {

  validate(control: FormControl): {} {
    if (!!control.value?.match('[0-9]+') && +control.value >= 1 && +control.value <= 12) {
      return null;
    }
    return {ERROR: 'DATUM.MONAT_UNGUELTIG'};
  }
}
